import client from './client'

const apiBasePath = '/api/admin/account/entry/'

export default {
  search: entryForm => client.post(apiBasePath + 'search', entryForm),
  approve: entryForm => client.post(apiBasePath + 'approve', entryForm),
  reject: entryForm => client.post(apiBasePath + 'reject', entryForm),
  detail: entryForm => client.post(apiBasePath + 'detail', entryForm),
  getEntry: entryForm => client.post(apiBasePath + 'getEntry', entryForm),
  update: entryForm => client.post(apiBasePath + 'update', entryForm)
}
